import React, { useRef } from 'react';
var VeltNotificationsPanelContentDocuments = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-documents", { ref: ref }, children));
};
export default VeltNotificationsPanelContentDocuments;
